module.exports = __webpack_public_path__ + "static/bohater_2-3707484c8ae50e502ef2db6e5617b22f.png";